import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sparkle, ArrowClockwise, ChartLineUp } from "@phosphor-icons/react";
import { toast } from "sonner";
import api from "@/lib/api";
import ForecastChart from "@/components/ForecastChart";

export default function ForecastPanel() {
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const run = async () => {
    setLoading(true); setResult(null);
    try {
      const { data } = await api.post("/v1/ai/forecast");
      setResult(data);
      toast.success("Forecast Claude generato");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Errore forecast");
    } finally { setLoading(false); }
  };

  return (
    <div className="bg-[#111827] border border-slate-800 rounded-lg" data-testid="forecast-panel">
      <div className="px-5 py-4 border-b border-slate-800 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <ChartLineUp size={20} weight="duotone" className="text-[#F59E0B]" />
          <div>
            <div className="text-xs uppercase tracking-widest text-slate-500 font-semibold">Predictive Forecast</div>
            <div className="font-heading text-lg text-white">ARERA 30 giorni</div>
          </div>
        </div>
        <Button onClick={run} disabled={loading} data-testid="forecast-run-button"
          className="bg-[#F59E0B] hover:bg-amber-600 text-[#070B14] font-semibold gap-2">
          {loading ? <ArrowClockwise className="animate-spin" size={14} /> : <Sparkle weight="fill" size={14} />}
          {loading ? "Analisi trend..." : "Genera previsione"}
        </Button>
      </div>

      <div className="p-5">
        {!result && !loading && (
          <div className="text-xs font-mono text-slate-500 text-center py-8">
            Claude analizzerà M1a e M1b sui trend live / 30gg / 1anno e restituirà una previsione strutturata a 30 giorni + grafico sovrapposto.
          </div>
        )}
        {loading && (
          <div className="text-xs font-mono text-slate-500 text-center py-8">Claude sta valutando trend storici...</div>
        )}
        {result && (
          <div className="space-y-5" data-testid="forecast-result">
            <div className="grid grid-cols-3 gap-3 text-center">
              {[
                { label: "Live", data: result.current, color: "#3EB6F0" },
                { label: "Media 30gg", data: result.avg_30d, color: "#94A3B8" },
                { label: "Prev. 30gg", data: { m1a_pct: result.series?.m1a_forecast_value, m1b_m3_km_gg: result.series?.m1b_forecast_value }, color: "#F59E0B" },
              ].map((b) => (
                <div key={b.label} className="border border-slate-800 rounded-md p-3 bg-[#0a0f1c]">
                  <div className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mb-1">{b.label}</div>
                  <div className="font-mono text-lg font-semibold" style={{ color: b.color }}>
                    {b.data?.m1a_pct}% <span className="text-slate-500 text-xs">M1a</span>
                  </div>
                  <div className="font-mono text-xs text-slate-400 mt-1">
                    {b.data?.m1b_m3_km_gg} <span className="text-slate-500">m³/km/gg M1b</span>
                  </div>
                </div>
              ))}
            </div>

            {result.series && (
              <div className="border border-slate-800 rounded-md p-4 bg-[#0a0f1c] space-y-4">
                <ForecastChart series={result.series} metric="m1a" />
                <ForecastChart series={result.series} metric="m1b" />
              </div>
            )}

            <div className="border border-slate-800 rounded-md p-4 bg-[#0a0f1c]">
              <div className="text-[10px] font-mono uppercase tracking-widest text-[#F59E0B] mb-3 flex items-center gap-2">
                <Sparkle weight="fill" size={12} /> Previsione Claude · {result.model}
              </div>
              <div className="text-sm text-slate-200 leading-relaxed whitespace-pre-wrap font-sans">{result.forecast}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
